/**
 * 受診者番号 exact-match rule shared by every 受診者 search box (受診者情報入力, 施術入力, 訪問入力).
 *
 * The search API matches 受診者番号 with LIKE %keyword%, so typing 「1」 also returns 10, 11, 21…
 * A2/R2 matched 受診者番号 with `=` instead, so a typed number that is an existing 受診者番号
 * always resolves to that one 受診者. The API orders that exact match first; these helpers find it.
 */
type PatientSerialNumberSource = {
  serial_number?: unknown;
  patient?: { serial_number?: unknown } | null;
};

const toSearchText = (value: unknown): string => (value == null ? '' : String(value));

export const hasExactSerialNumberMatch = (
  patient: PatientSerialNumberSource,
  keyword: string
): boolean => {
  return (
    toSearchText(patient.patient?.serial_number) === keyword ||
    toSearchText(patient.serial_number) === keyword
  );
};

/** The 受診者 whose 受診者番号 equals the trimmed keyword, if the results contain one. */
export const findExactSerialNumberMatch = <T extends PatientSerialNumberSource>(
  patients: readonly T[],
  keyword: string
): T | undefined => {
  const trimmed = keyword.trim();
  if (!trimmed) return undefined;
  return patients.find(patient => hasExactSerialNumberMatch(patient, trimmed));
};
